import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import styled from "@emotion/styled";

import AreaTypes from "types/AreaTypes";
import PointTypes from "types/PointTypes";
import PathTypes from "types/PathTypes";

import ParkkiTheme from "themes/ParkkiTheme";
import SelectedChips from "components/SelectedChips";

const Container = styled.div`
  padding-bottom: ${ParkkiTheme.spacings.xsmall};
`;
const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const SelectAllContainer = styled.div`
  margin-left: 4px;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

type Props = {
  label: string;
  layers: AreaTypes[] | PointTypes[] | PathTypes[];
  onSelectLayers: Function;
  color?: string;
};

function SelectedChipsSection({ color, label, layers, onSelectLayers }: Props) {
  const { formatMessage } = useIntl();

  const nbSelectedLayers = useMemo(() => {
    // @ts-ignore
    return layers?.filter((layer) => layer.selected)?.length;
  }, [layers]);

  if (nbSelectedLayers === 0) {
    return null;
  }
  function handleUnselectAllLayers() {
    onSelectLayers([]);
  }

  return (
    <Container>
      <LabelContainer>
        <div>{label}</div>

        <SelectAllContainer onClick={handleUnselectAllLayers}>
          {formatMessage({
            id: `components.selectALayerInfo.unselectAll`,
          })}
        </SelectAllContainer>
      </LabelContainer>

      <SelectedChips
        layers={layers}
        onSelectLayers={onSelectLayers}
        color={color}
      />
    </Container>
  );
}

export default SelectedChipsSection;
